import { render } from "./MemberSignUp.vue?vue&type=template&id=a822d134&scoped=true"
import script from "./MemberSignUp.vue?vue&type=script&lang=js"
export * from "./MemberSignUp.vue?vue&type=script&lang=js"

import "./MemberSignUp.vue?vue&type=style&index=0&id=a822d134&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a822d134"]])

export default __exports__